class ManageSimulatorSimulationDataModalController {
    constructor(SimulationDataServiceApi, toastr, ModalService) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.data = {
                simulator: null,
                simulationDataTypes: null,
                allDataModels: null,
                selectedDataModels: null
            };
            this.state = {
                showSpinner: true,
                itemRemoved: false
            };
            this.data.simulator = angular.copy(this.resolve.sim);
            this.SimulationDataServiceApi.getModels().then((response) => {
                this.data.allDataModels = response.data;
                this.SimulationDataServiceApi.getModelsForSimulator(this.data.simulator.Id).then((response) => {
                    this.data.selectedDataModels = response.data;
                    // Remove the items from allDataModels that are present in selectedDataModels. Don't want duplicates
                    _.remove(this.data.allDataModels, (model) => {
                        var findDef = _.find(this.data.selectedDataModels, (searchDef) => {
                            return searchDef.Id === model.Id;
                        });
                        return !_.isNil(findDef);
                    });
                    this.state.showSpinner = false;
                });
            });
        };
        this.add = (model) => {
            _.remove(this.data.allDataModels, (searchDef) => {
                return searchDef.Id === model.Id;
            });
            this.data.selectedDataModels.push(model);
        };
        this.remove = (model) => {
            _.remove(this.data.selectedDataModels, (searchDef) => {
                return searchDef.Id === model.Id;
            });
            this.data.allDataModels.push(model);
            this.state.itemRemoved = true;
        };
        this.update = () => {
            if (this.state.itemRemoved) {
                let modalOptions = {
                    backdrop: 'static',
                    actionButtonText: 'Continue',
                    closeButtonText: 'Cancel',
                    headerText: 'Simulation Data Model Removed',
                    bodyText: 'You have removed a simulation data model from the simulator. Any instances already set up by users will be permanently removed too.'
                };
                this.ModalService.showModal({}, modalOptions).then(() => {
                    this.save();
                    this.state.itemRemoved = false;
                });
            }
            else {
                this.save();
            }
        };
        this.save = () => {
            this.SimulationDataServiceApi.saveModelsForSimulator(this.data.simulator.Id, this.data.selectedDataModels)
                .then((response) => {
                if (!_.isNil(response)) {
                    this.toastr.info('Simulation data updated');
                }
                this.dismiss();
            });
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.SimulationDataServiceApi = SimulationDataServiceApi;
        this.toastr = toastr;
        this.ModalService = ModalService;
    }
}
angular.module('app').component('manageSimulatorSimulationDataModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/SimulationData/admin/manage-simulator-simulation-data-modal.tpl.html',
    controllerAs: 'vm',
    controller: ManageSimulatorSimulationDataModalController
});
